const featuresData = [
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过10万部国产电影、电视剧及自制剧，涵盖动作、悬疑、喜剧、古装、都市、科幻等全部类型，满足各类观影需求。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站支持1080P高清播放，热门影片提供4K超清画质。先进的视频编码技术确保画面细腻、色彩饱满，还原影院级视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '采用全球CDN加速节点，智能匹配最佳线路，确保影片即点即播，告别缓冲等待。无论何时何地，流畅观影不打折。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '编辑团队每日精选更新，第一时间上架最新国产影视资源。从院线新片到热播剧集，不错过任何一部好作品。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '全面兼容桌面、平板、手机等各类设备。自适应屏幕尺寸和网络环境，在家用大屏看，出门用手机看，观影不间断。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            五年深耕国产影视领域，用心打磨每一个观影细节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {featuresData.map((item) => (
            <div
              key={item.title}
              className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}